import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import { hasPermission } from '../../hooks/usePermission';
import { getRole } from '../../utils/role';

const FarmersTable = ({ users, startIndex = 1 }) => {
  const navigate = useNavigate();
  const role = getRole();

  // Helper function to format date safely
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '-';
      return date.toLocaleDateString('en-IN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    } catch (error) {
      return '-';
    }
  };

  // Calculate dynamic colSpan based on permissions
  const calculateColSpan = () => {
    let count = 9; // Base columns: S.No., First, Last, Mobile, Address, Pincode, State, City, Onboarding Date
    if (hasPermission('farmers:partner')) count++;
    if (hasPermission('farmers:report_count')) count++;
    count++; // Actions column
    return count;
  };

  return (
    <table className="table table-striped text-center table-borderless align-middle">
      <thead className="table-dark">
        <tr>
          <th>S.No.</th>
          <th>FIRST NAME</th>
          <th>LAST NAME</th>
          <th>MOBILE</th>
          <th>ADDRESS</th>
          <th>PINCODE</th>
          <th>STATE</th>
          <th>CITY</th>
          <th>FARMER ONBOARDING DATE</th>

          {hasPermission('farmers:partner') && <th>PARTNER</th>}
          {hasPermission('farmers:report_count') && <th>REPORT COUNT</th>}

          <th>ACTIONS</th>
        </tr>
      </thead>

      <tbody>
        {users.length > 0 ? (
          users.map((user, index) => (
            <tr key={`${user.user_id}_${index}`}>
              <td>{startIndex + index}</td>
              <td className="text-capitalize">{user.first_name}</td>
              <td className="text-capitalize">{user.last_name}</td>
              <td>{user.mobile_no}</td>
              <td>{user.address}</td>
              <td>{user.pincode}</td>
              <td>{user.state}</td>
              <td>{user.city}</td>
              <td>{formatDate(user.created_at)}</td>

              {hasPermission('farmers:partner') && (<td>{user.entity_name || user.source || 'NA'}</td>)}

              {hasPermission('farmers:report_count') && (
                <td>{user.report_count ?? '-'}</td>
              )}

              <td>
                <div className="d-flex gap-2 justify-content-center">
                  {hasPermission('farmers:book') && (
                    <Button
                      size="sm"
                      variant="primary"
                      onClick={() =>
                        navigate(`/users/booking/${user.user_id}`)
                      }
                    >
                      Book
                    </Button>
                  )}

                  {/* VIEW */}
                  {hasPermission('farmers:view') && (
                    <>
                      {role === 'FIELD_OFFICER' && user.follow_up_form_ind ? (
                        <span className="text-muted">-</span>
                      ) : (
                        <Button
                          size="sm"
                          variant="warning"
                          onClick={() => navigate(`/users/${user.user_id}`)}
                        >
                          View
                        </Button>
                      )}
                    </>
                  )}

                  {/* UPDATE */}
                  {hasPermission('farmers:update') && (
                    <Button
                      size="sm"
                      variant="danger"
                      onClick={() =>
                        navigate(`/users/update-data/${user.user_id}`)
                      }
                    >
                      Update
                    </Button>
                  )}
                </div>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={calculateColSpan()}>No Entries Found...</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default FarmersTable;